import { styled } from '@openeducation/oe-it-themes';
import React, { FC, useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';

interface RecordingBarProps {
  range: [number, number];
}

export const RecordingBar: FC<RecordingBarProps> = ({ range }) => {
  const animationRef = useRef(new Animated.Value(0));

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.delay(Math.random() * 100),
        Animated.timing(animationRef.current, {
          toValue: 1,
          useNativeDriver: false,
          duration: 300,
          easing: Easing.ease,
        }),
        Animated.timing(animationRef.current, {
          toValue: 0,
          useNativeDriver: false,
          duration: 300,
          easing: Easing.ease,
        }),
      ])
    );

    animation.start();

    return () => {
      animation?.stop?.();
    };
  }, []);

  return (
    <Bar
      style={{
        height: animationRef.current.interpolate({
          inputRange: [0, 1],
          outputRange: range,
        }),
      }}
    />
  );
};

const Bar = styled(Animated.View)`
  background-color: ${({ theme }) => theme.color.primaryLight};
  width: 6px;
  height: 16px;
  border-radius: 40px;
  margin: 0 3px;
`;
